<style>

    .btn-file {
        position: relative;
        overflow: hidden;
    }

        .btn-file input[type=file] {
            position: absolute;
            top: 0;
            right: 0;
            min-width: 100%;
            min-height: 100%;
            font-size: 100px;
            text-align: right;
            filter: alpha(opacity=0);
            opacity: 0;
            outline: none;
            background: white;
            cursor: inherit;
            display: block;
        }

    .cropit-preview {
        /* You can specify preview size in CSS */
        width: 150px;
        height: 200px;
    }


    input[type=range] {
        -webkit-appearance: none;
        margin-top: 0.5rem;
        width: 100%;
        border: none !important;
        background: transparent;
        padding: 0;
    }

        input[type=range]:focus {
            outline: none;
        }

        input[type=range]::-webkit-slider-runnable-track {
            width: 100%;
            height: 0.3rem;
            cursor: pointer;
            animate: 0.2s;
            background: #eee;
            border-radius: 5px;
        }

        input[type=range]::-webkit-slider-thumb {
            height: 1rem;
            width: 1rem;
            border-radius: 0.5rem;
            background: #0275d8;
            cursor: pointer;
            -webkit-appearance: none;
            margin-top: -0.35rem;
        }

        input[type=range]::-moz-range-track {
            width: 100%;
            height: 0.3rem;
            cursor: pointer;
            animate: 0.2s;
            background: #eee;
            border-radius: 5px;
        }

        input[type=range]::-moz-range-thumb {
            height: 1rem;
            width: 1rem;
            border-radius: 0.5rem;
            background: #0275d8;
            cursor: pointer;
        }

        input[type=range]::-ms-track {
            width: 100%;
            height: 0.3rem;
            cursor: pointer;
            background: transparent;
            color: transparent;
        }

        input[type=range]::-ms-fill-lower {
            background: #e1e1e1;
            border-radius: 10px;
        }

        input[type=range]::-ms-fill-upper {
            background: #eee;
            border-radius: 10px;
        }

        input[type=range]::-ms-thumb {
            height: 1rem;
            width: 1rem;
            border-radius: 0.5rem;
            background: #0275d8;
            cursor: pointer;
        }

        input[type=range]:focus::-ms-fill-lower {
            background: #eee;
        }
    /* Show load indicator when image is being loaded */
    .cropit-preview.cropit-image-loading .spinner {
        opacity: 1;
    }
    /* Show move cursor when image has been loaded */
    .cropit-preview.cropit-image-loaded .cropit-preview-image-container {
        cursor: move;
    }
    /* Translucent background image */
    .cropit-preview-background {
        opacity: .2;
    }

    /*
    * If the slider or anything else is covered by the background image,
    * use relative or absolute position on it
    */
    input.cropit-image-zoom-input {
        position: relative;
    }

    /* Limit the background image by adding overflow: hidden */
    #image-cropper {
        overflow: hidden;
    }
</style>

<template>
    <div class="form-group ">
        <label class="col-md-3 control-label">Upload Image</label>
        <div class="col-md-9">
            <!-- This wraps the whole cropper -->
            <div id="image-cropper">
                
                    <div class="row" style="overflow: hidden;" v-show="imageSelected">
                        <!-- This is where the preview image is displayed -->
                        <div class="cropit-preview center-block"></div>
                    </div>
                    <div class="row">
                        <br />
                        <div class="col-sm-12 center-block">
                            <button @click.prevent="acw">
                                <i class="fa fa-undo"></i>
                            </button>
                            <button @click.prevent="cw">
                                <i class="fa fa-repeat "></i>
                            </button>
                            <div class="col-sm-6"><input type="range" class="cropit-image-zoom-input" /></div>
                        </div>
                    </div>
                <div>
                    <!-- This is where user selects new image -->
                    
                    <label class="btn btn-default btn-file col-md-3">
                        Browse <input type="file" class="cropit-image-input" @change="fileSelected" />
                    </label>

                </div>
            </div>
        </div>
    </div>
</template>
<script>

    import $ from 'jquery';
    import cropit from 'cropit';

    export default {
        props: ['value', 'updateImageData'],
        watch: {
            updateImageData() {
                this.UpdateImageData();
            }
        },
        data: function () {
            return {
                imageSelected: false,
                el: {}
            }
        },
        mounted: function () {
            var that = this;
            this.el = $('#image-cropper');
            this.el.cropit({
                allowDragNDrop: false,
                imageBackground: true,
                onFileChange: function () {

                    console.log('onFileChange')
                    that.UpdateImageData();
                },
                onZoomChangefunction: function () {
                    console.log('onZoomChangefunction')
                    that.UpdateImageData();
                },
                onOffsetChangefunction: function () {

                    console.log('onOffsetChangefunction')
                    that.UpdateImageData();
                }
            });
        },
        methods: {
            cw: function (e) {
                $('#image-cropper').cropit('rotateCW');
            },
            acw: function (e) {
                $('#image-cropper').cropit('rotateCCW');
            },
            fileSelected: function (event) {
                // Reference to the DOM input element
                var input = event.target;
                // Ensure that you have a file before attempting to read it
                if (input.files && input.files[0]) {
                    this.$data.imageSelected = true;
                }
            }
            ,
            UpdateImageData() {
                //var imageData = $(this.el).cropit('export', {
                //    type: 'image/jpeg',
                //    quality: 0.8,
                //    originalSize: true,
                //});

                //console.log(imageData);
                //this.$emit('input', imageData);
                var imageData = $('#image-cropper').cropit('export', {
                    type: 'image/jpeg',
                    quality: .9,
                    originalSize: true
                });
                if (imageData) {
                    console.log(imageData);
                    this.$emit('input', imageData);
                } else {
                    this.$emit('input', '');
                }
            }
        }
    }
</script>


// WEBPACK FOOTER //
// formimage.scp.html?15c8de7a